import { WarrantyLogService } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const warrantyWipInfoQueryKey = 'warrantyWipInfoQueryKey';

export type WarrantyWipInfoFilter = {
  wipNo: number;
  branchId: number;
};

export const useWarrantyWipInfoQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  input: WarrantyWipInfoFilter,
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof WarrantyLogService.getWarrantyLogWipInfo>>,
      QueryError,
      Awaited<ReturnType<typeof WarrantyLogService.getWarrantyLogWipInfo>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery(
    [warrantyWipInfoQueryKey, ...(queryKey ?? [{ ...input }])],
    () => WarrantyLogService.getWarrantyLogWipInfo(input.wipNo, input.branchId),
    options
  );
